import React from 'react';
import { ResultsContent } from './components/AdminResultsContent/AdminResultsContent';
import { ResultsSidebar } from './components/AdminResultsSidebar/AdminResultsSidebar';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useActiveLeaderboardEvent } from '../../hooks/useActiveLeaderboardEvent';
import { StatusBadge } from '../../Components/StatusBadge/StatusBadge';
import './AdminResults.scss';

export const AdminResults: React.FC = () => {
  const { width } = useWindowDimensions();
  const { activeEvent } = useActiveLeaderboardEvent();

  return (
    <div className="results-page">
      <h1>Results {activeEvent && <StatusBadge isActive={activeEvent.isActive} />}</h1>
      <div className="results-main">
        <ResultsContent />
        {width > 768 && <ResultsSidebar selectedEvent={activeEvent} />}
      </div>
    </div>
  );
};
